export const tokens = {
  radius: "8px",
  radiusFull: "9999px",
  bg: "#f3f4f6",
  shimmer: "#e5e7eb",
  spacing: {
    sm: 12,
    md: 16,
    lg: 24,
  },
  shadow: "0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)",
  shadowMd: "0 4px 12px rgba(0, 0, 0, 0.06)",
} as const;
